import { msalInstance } from "../index";
import {acquireAccessToken, getAccountId} from "./api/auth";
import { env } from "../config/env";

export let ws;

const messageHandlers = new Set();
export const addMessageHandler = (action, handler) => {
    let handlerInfo = {action: action, handler: handler};
    messageHandlers.add(handlerInfo);
}

export const removeMessageHandler = (handler) => {
    for (let messageHandlerInfo of messageHandlers) {
        let currentHandler = messageHandlerInfo?.handler;
        if (currentHandler === handler) {
            messageHandlers.delete(messageHandlerInfo);
        }
    }
}

export async function handleLogout(redirectURL = '/') {
    try {
        let accessToken = await acquireAccessToken(msalInstance);
        let userId = await getAccountId(msalInstance);
        let wsInstance = await connect();

        localStorage.removeItem('mainNavItem');
        localStorage.removeItem('pageName');
        await sendMessage(wsInstance, JSON.stringify({accessToken: accessToken, userId: userId, didUserLogout: true}));
    } catch(error) {
        console.log(error)
    }

    await msalInstance.logoutRedirect({postLogoutRedirectUri: redirectURL});
}

export async function connect(userId, accessToken, timestamp, forceReconnect=false) {
    if (ws && !forceReconnect) {
        console.log('Socket instance already created.')
        return ws;
    }

    console.log('Initializing websocket connection.')
    ws = new WebSocket(env('REACT_APP_PHARO_BACKEND_WEBSOCKET_API_URL'));

    ws.onopen = function () {
        console.log('onopen:')
        if (!userId || !accessToken || !timestamp) {
            return;
        }

        const subdomain = window.location.hostname.split('.')[0];
        const message = {userId: userId, accessToken: accessToken, timestamp: timestamp, companyName: subdomain};
        ws.send(JSON.stringify(message));
    };

    ws.onmessage = async (e) => {
        const message = e.data;
        console.log('onmessage: ', message)

        if (message) {
            let messageObj = JSON.parse(message);
            // isForcedLogout = when a user explicitly logs out; it will log out any previously open sessions for the user
            // shouldLogout = when a user explicitly logs in; it will log out any previous open sessions for the user
            if (messageObj.isForcedLogout === true) {
                await msalInstance.logoutRedirect({postLogoutRedirectUri: `${window.location.origin}`});
            } else if (messageObj.shouldLogout === true) {
                await msalInstance.logoutRedirect({postLogoutRedirectUri: `${window.location.origin}/session-logout`});
            } else if (messageObj.action) {
                messageHandlers.forEach((handlerInfo) => {
                    let action = handlerInfo?.action;
                    let handler = handlerInfo?.handler;

                    // only broadcast to those who are listening to the correct action
                    if (action && handler && messageObj.action === action) {
                        handler(messageObj);
                    }
                });
            }
        }
    };

    ws.onclose = function (e) {
        console.log('Socket is closed.', e.reason);
        setTimeout(async function () {
            await connect(userId, accessToken, timestamp, true);
        }, 1000);
    };

    return ws;
}

// We must wait for an open connection before sending a message
// Reference: https://dev.to/ndrbrt/wait-for-the-websocket-connection-to-be-open-before-sending-a-message-1h12
const waitForOpenConnection = (socket) => {
    return new Promise((resolve, reject) => {
        const maxNumberOfAttempts = 10;
        const intervalTime = 200; //ms

        let currentAttempt = 0;
        const interval = setInterval(() => {
            if (currentAttempt > maxNumberOfAttempts - 1) {
                clearInterval(interval);
                reject(new Error('Maximum number of attempts exceeded'));
            } else if (socket.readyState === socket.OPEN) {
                clearInterval(interval);
                resolve();
            }
            currentAttempt++
        }, intervalTime)
    })
}

const sendMessage = async (socket, msg) => {
    if (socket.readyState !== socket.OPEN) {
        try {
            await waitForOpenConnection(socket);
            socket.send(msg);
        } catch (err) { console.error(err) }
    } else {
        socket.send(msg);
    }
}
